
import './App.css';
import Home from './components/Home/Home.jsx';
import { Route, Routes } from "react-router-dom"
import About from './components/About/About.jsx';
import Stocks from './components/Stocks/Stocks.jsx';
import GrowthTracker from './components/GrowthTracker/GrowthTracker.jsx';
import MyToolkit from './components/MyToolkit/MyToolkit.jsx';
import Milestone from './components/Milestone.jsx';
import AdminLogin from './pages/Admin/AdminLogin.jsx';
import AdminDashboard from './pages/Admin/AdminDashboard.jsx';
import ProtectedRoute from './components/Admin/ProtectedRoute.jsx';
import AdminWallets from './pages/Admin/AdminWallets.jsx';
import AdminTransactions from './pages/Admin/AdminTransactions.jsx';
import AdminStocks from './pages/Admin/AdminStocks.jsx';
import AdminDividends from './pages/Admin/AdminDividends.jsx';
import AdminInsights from './pages/Admin/AdminInsights.jsx';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/stocks" element={<Stocks />} />
      <Route path="/milestones" element={<Milestone />} />
      <Route path="/growth_tracker" element={<GrowthTracker />} />
      <Route path="/my_toolkit" element={<MyToolkit />} />
            <Route path="/admin/login" element={<AdminLogin />} />
      <Route
        path="/admin/dashboard"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/wallets"
        element={
          <ProtectedRoute>
            <AdminWallets />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/transactions"
        element={
          <ProtectedRoute>
            <AdminTransactions />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/stocks"
        element={
          <ProtectedRoute>
            <AdminStocks />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/dividends"
        element={
          <ProtectedRoute>
            <AdminDividends />
          </ProtectedRoute>
        }
      />
      <Route path="/admin/insights" element={<ProtectedRoute><AdminInsights /></ProtectedRoute>} />
    </Routes>
  );
}

export default App;
